import React from 'react'
import { Badge, TakeAways, LazyLoad, SeoHelmet } from '../../common/Functions'
import Roles from './roles'
import Ecosystem from './ecosystem'
import Branding from './branding'

function Seeyoudoc() {
  return (
   <div id="works">
    <SeoHelmet title="SeeYouDoc" description="An online platform built to provide a holistic experience between patients, medical facilities, and medical societies." />
    <section className="banner seeyoudoc px-0">
      <div className="max-w-screen-xl	mx-auto">
        <main className="mt-10">
          <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
            <div className="lg:w-7/12 md:w-full inline-flex lg:justify-end ml-5 lg:ml-0 mt-10">
              <div className="content">
                <h1 className="text-left font-bold text-3xl text-white">
                  An online platform built to provide a holistic experience between patients, medical facilities, and medical societies.
                </h1>
                <p className="text-white mt-10">
                  See how I help innovate and provide better healthcare solutions through design.
                </p>
                <div className="roles mt-20">
                  <Badge title="Product Manager" />
                  <Badge title="UX/UI Design" />
                  <Badge title="Branding" />
                  <Badge title="Web & Mobile Application" />
                </div>
              </div>
            </div>
            <div className="lg:w-5/12 md:w-full sm:order-first md:order-first lg:order-last">
              <LazyLoad className="inline" src={require('../../common/images/seeyoudoc/syd-white.svg')} alt="Seeyoudoc Logo"/>
            </div>
          </div>
        </main>
      </div>
      </section>
      <Roles />
      <Ecosystem />
      <Branding />
      <TakeAways content="It was an exceptional experience for me as I started my career as a product designer. I was able to lead a team of designers to create new features and improvements to existing experiences. Also, I was able to work and collaborate with different groups throughout the design and development process from definition, design, build, test, release, and maintenance. My participation in designing product branding is valuable as a backbone of the present marketing materials. This project is one of the special projects for me because of the mission to help my fellow Filipinos to innovate and provide accessible healthcare solutions." />
   </div>
  )
}

export default Seeyoudoc
